<template>
  <div class="step" :class="{ 'step_active': active }">
    <div class="step__inner">
      <h3 class="step__title">Банковские реквизиты Выгодоприобретателя<br class="onlydesk"> для получателя выплаты</h3>
      <TextInput :required="true" @setError="errors.receiver = $event" v-model="form.bankdata.receiver" text="ФИО получателя выплаты (Выгодоприобретателя):" name="bankdata-receiver" @update:modelValue="suggestName($event)" :validation="(v) => v ? ((v.split(' ').filter(el => el.trim()).length < 2) ? 'Заполните поле' : '') : ''" :options="fullnameSuggest" :blurcondition="form.bankdata.receiver.split(' ').filter(el => el.trim()).length >= 3" />
      <NumberInput :required="true" :forceError="BIKerror" mask="#########" :filled="(v) => v.length == 9" @setError="errors.BIK = $event" v-model="form.bankdata.BIK" text="БИК банка получателя:" name="bankdata-BIK" />
      <TextInput :required="true" :disabled="true" @setError="errors.bankname = $event" v-model="form.bankdata.bankname" text="Наименование банка:" name="bankdata-bankname" />
      <NumberInput :required="true" mask="######################" @setError="errors.accountNumber = $event" v-model="form.bankdata.accountNumber" text="Номер лицевого счета получателя:" :filled="(v) => v.length > 0 && v.length <= 22" name="bankdata-accountNumber" />
      <CheckBox :smtext="true" name="bankdata-confirm" v-model="form.bankdata.confirm">
        Подтверждаю ознакомление с
        <a :href="agreementlink1" target="_blank">соглашением</a> о порядке электронного взаимодействия и даю согласие на обработку и передачу
        <a :href="agreementlink2" target="_blank">персональных данных</a>.
      </CheckBox>
      <Btn class="step__next" :disabled="!filled" @click.stop.prevent="$store.commit('nextStep')">Далее</Btn>
    </div>
  </div>
</template>

<script>
import Btn from '../Btn.vue';
import { mapState } from 'vuex';
import TextInput from '../inputs/TextInput.vue';
import CheckBox from '../inputs/CheckBox.vue';
import NumberInput from '../inputs/NumberInput.vue';
import nameSuggest from '../../mixins/nameSuggest';

export default {
  components: { Btn, TextInput, CheckBox, NumberInput },
  mixins: [nameSuggest],
  props: {
    active: { type: Boolean }
  },
  data: () => ({
    timer: undefined,
    errors: {},
    agreementlink1: '/docs/soglashenie_o_poryadke_elektronnogo_vzaimodei_stviya.pdf',
    agreementlink2: '/about/politics/',
    suggestionSuccess: false
  }),
  computed: {
    ...mapState(['form']),
    filled() {
      for (let key in this.errors)
        if (this.errors[key]) return false
      let required = ['receiver', 'BIK', 'bankname', 'accountNumber', 'confirm']
      for (let key of required)
        if (!this.form.bankdata[key]) return false

      return true
    },
    BIKerror() {
      if (this.form.bankdata.BIK.length != 9) return ''
      switch (this.suggestionSuccess) {
        case false:
          return 'Ошибка. Запрос на проверку БИК не был отправлен'
        case 'error':
          return 'Банка с данным БИК не существует'
        case 'request_wait':
          return 'Ожидание проверки БИК...'
        case 'request_sended':
          return 'Идёт проверка БИК...'
        case true:
          return ''
        default:
          return ''
      }
    }
  },
  methods: {
    checkBIK(v) {
      this.suggestionSuccess = 'request_sended'
      var url = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/findById/bank"
      var token = this.$store.state.DaDataToken
      var query = v;
      var options = {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": "Token " + token
        },
        body: JSON.stringify({ query: query })
      }

      fetch(url, options)
        .then(response => response.json())
        .then(result => {
          if (result.suggestions?.length) {
            this.form.bankdata.bankname = result.suggestions[0].value
            this.suggestionSuccess = true
          } else
            this.suggestionSuccess = 'error'
        })
        .catch(error => console.error(error))
    }
  },
  watch: {
    'form.bankdata.BIK': {
      handler: async function (v) {
        this.suggestionSuccess = false
        this.form.bankdata.bankname = ''
        if (v.length < 9) {
          clearTimeout(this.timer)
          this.timer = undefined
        }
        if (v.length == 9) {
          if (!this.timer) {
            this.checkBIK(v)
            this.timer = setTimeout(() => this.timer = undefined, 500)
          }
          else {
            this.suggestionSuccess = 'request_wait'
            clearTimeout(this.timer)
            this.timer = setTimeout(() => {
              this.checkBIK(v)
              this.timer = undefined
            }, 500)
          }
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="sass">

</style>